import {TECHNICAL_ERROR} from '../actions';

export default function error(state = false, action) {
  switch (action.type) {
    case TECHNICAL_ERROR:
      return action.isError;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./chat-app/reducers/error.js